import Vue from 'vue'
import { alpha3ToAlpha2, registerLocale } from 'i18n-iso-countries'
import merge from 'lodash/merge'
import moment from 'moment'
import VueMoment from 'vue-moment'

import router from './router'
import App from './App.vue'
import { store } from './store'
import { i18n } from './i18n'
import './vee-validate'
import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'
import auth from '@/auth'
import vuetify from '@/plugins/vuetify'
import countriesData from '@/data/countries.json'
import VueCountdown from '@chenfengyuan/vue-countdown'
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib'
import DatetimePicker from 'vuetify-datetime-picker'
import FilterDialog from '@/components/FilterDialog.vue'
import OSelectLocations from '@/components/OSelectLocations.vue'
import OLocationSuggestionInput from '@/components/inputs/OLocationSuggestionInput.vue'
import OCatalogSearch from '@/components/inputs/OCatalogSearch.vue'
import OListSelect from '@/components/inputs/OListSelect.vue'

import { defaultTheme } from './helpers/constante'
import { EventBus } from '@/event-bus'
import { resolveValue } from './helpers/helper'
import { localizeCountries } from './helpers/countries'

import UnifiedStockPlugin from 'unified-stock-front'

Amplify.configure({
  API: {
    endpoints: [
      {
        name: 'orders',
        endpoint: process.env.VUE_APP_API_URL,
        region: process.env.VUE_APP_API_REGION,
      },
      {
        name: 'sub-orders',
        endpoint: process.env.VUE_APP_API_URL,
        region: process.env.VUE_APP_API_REGION,
      },
      {
        name: 'partners',
        endpoint: process.env.VUE_APP_API_URL,
        region: process.env.VUE_APP_API_REGION,
      },
      {
        name: 'locations',
        endpoint: process.env.VUE_APP_API_URL_LOCATION,
        region: process.env.VUE_APP_API_REGION,
      },
      {
        name: 'orchestration-rules',
        endpoint: process.env.VUE_APP_API_URL,
        region: process.env.VUE_APP_API_REGION,
      },
      {
        name: 'appointments',
        endpoint: process.env.VUE_APP_STORE_APPOINTMENT_API_URL,
        region: process.env.VUE_APP_API_REGION,
      },
      {
        name: 'settings',
        endpoint: process.env.VUE_APP_API_URL,
        region: process.env.VUE_APP_API_REGION,
      },
      {
        name: 'returns',
        endpoint: process.env.VUE_APP_RETURN_API_URL,
        region: process.env.VUE_APP_API_REGION,
      },
      {
        name: 'partner-settings',
        endpoint: process.env.VUE_APP_API_URL,
        region: process.env.VUE_APP_API_REGION,
      },
      {
        name: 'inventory',
        endpoint: process.env.VUE_APP_INVENTORY_API_URL,
      },
      {
        name: 'triggers',
        endpoint: process.env.VUE_APP_TRIGGER_API_URL,
        region: process.env.VUE_APP_API_REGION,
      },
      {
        name: 'order-workflows',
        endpoint: process.env.VUE_APP_API_URL,
        region: process.env.VUE_APP_API_REGION,
      },
      {
        name: 'ebookings',
        endpoint: process.env.VUE_APP_EBOOKING_API_URL,
        region: process.env.VUE_APP_API_REGION,
      },
      {
        name: 'payment',
        endpoint: process.env.VUE_APP_PAYMENT_API_URL,
        region: process.env.VUE_APP_API_REGION,
      },
      {
        name: 'stocks',
        endpoint: process.env.VUE_APP_UNIFIED_STOCK_API_URL,
        region: process.env.VUE_APP_API_REGION,
      },
      {
        name: 'templateEmails',
        endpoint: process.env.VUE_APP_TEMPLATE_MANAGER_API_URL,
        region: process.env.VUE_APP_API_REGION,
      },
      {
        name: 'parsingsHistory',
        endpoint: process.env.VUE_APP_PARSING_HISTORY_API_URL,
        region: process.env.VUE_APP_API_REGION,
      },
      {
        name: 'users',
        endpoint: process.env.VUE_APP_USER_API_URL,
        region: process.env.VUE_APP_API_REGION,
      },
      {
        name: 'carriers',
        endpoint: process.env.VUE_APP_CARRIERS_API_URL,
        region: process.env.VUE_APP_API_REGION,
      },
      {
        name: 'additionalServices',
        endpoint: process.env.VUE_APP_ADDITIONAL_SERVICES_URL,
        region: process.env.VUE_APP_API_REGION,
      },
      {
        name: 'tasks',
        endpoint: process.env.VUE_APP_TASK_API_URL,
        region: process.env.VUE_APP_API_REGION,
      },
      {
        name: 'catalog',
        endpoint: process.env.VUE_APP_API_URL,
        region: process.env.VUE_APP_API_REGION,
      },
      {
        name: 'configurations',
        endpoint: process.env.VUE_APP_CONFIGURATION_API_URL,
        region: process.env.VUE_APP_API_REGION,
      },
      {
        name: 'findInStore',
        endpoint: process.env.VUE_APP_FIND_IN_STORE_API_URL,
        region: process.env.VUE_APP_API_REGION,
      },
      {
        name: 'pick-pack-ships',
        endpoint: process.env.VUE_APP_API_URL,
        region: process.env.VUE_APP_API_REGION,
      },
    ],
  },
})
Vue.use(AmplifyPlugin, AmplifyModules)

Vue.prototype.$loadCountries = function (locale) {
  try {
    registerLocale(require(`i18n-iso-countries/langs/${locale}.json`))
  } catch (e) {
    console.error(`[CountriesAutocomplete] Locale "${locale}" not supported by i18n-iso-countries`, e)
    EventBus.$emit('displaySnackbar', { display: true, text: `Unsupported locale: ${locale}`, color: 'error' })
    return []
  }
  return localizeCountries(countriesData, locale)
}

Vue.use(auth)

Vue.use(VueMoment, {
  moment,
})

Vue.use(VueTelInputVuetify, {
  vuetify,
})

Vue.use(DatetimePicker)

Vue.component(VueCountdown.name, VueCountdown)

Vue.component(FilterDialog.name, FilterDialog)

Vue.component(OSelectLocations.name, OSelectLocations)

Vue.component(OLocationSuggestionInput.name, OLocationSuggestionInput)

Vue.component(OCatalogSearch.name, OCatalogSearch)

Vue.component(OListSelect.name, OListSelect)

Vue.config.productionTip = false

// Filters
Vue.filter('formatPrice', function (value, currency) {
  const priceMultiplier = currency ? Math.pow(10, currency.minor_unit) : 100
  let locale = navigator.language
  return new Intl.NumberFormat(locale).format(value / priceMultiplier)
})

//TODO, REPLACE THE FILTER ABOVE BY THE FOLLOWING LATER
// Vue.filter("formatPriceV2", function(value, currency) {
//   const priceMultiplier = currency ? Math.pow(10, currency.minor_unit) : 100
//   let locale = navigator.language
//   return new Intl.NumberFormat(locale,{ style: 'currency', currency: currency.code, currencyDisplay: "code" }).format(value / priceMultiplier) ;
// });

Vue.filter('formatBarCode', function (value) {
  if (value) {
    return value.toString().padStart(13, '0')
  } else {
    return value
  }
})

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toLowerCase()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.mixin({
  methods: {
    addToHeaders: function (settings, field, role) {
      let add = true
      if (settings) {
        const customerInfoSettings = settings[field]
        add = !customerInfoSettings || role === 'octipas-admin' || customerInfoSettings.includes(role)
      }
      return add
    },
  },
})

/**
 * Extract and merge store-specific theme overrides from partner configuration.
 *
 * @param {Object} storeDetails - Store details including country_id.
 * @param {Object} partnerTheme - Partner-provided theme configuration.
 * @returns {Object} Merged theme object.
 */
function buildCurrentTheme(storeDetails, partnerTheme) {
  const defaultThemeConfig = structuredClone(partnerTheme?.default ?? {})
  const countryId = storeDetails?.address?.country_id

  if (!countryId) {
    return defaultThemeConfig
  }

  const iso2Country = alpha3ToAlpha2(countryId)
  const countryOverride = partnerTheme?.[iso2Country]

  if (countryOverride) {
    merge(defaultThemeConfig, countryOverride)
  }

  return defaultThemeConfig
}

/**
 * Apply the given theme colors to Vuetify (light/dark).
 *
 * @param {Object} themeConfig - Theme configuration containing colors.
 * @param {Object} defaultTheme - Fallback theme configuration.
 */
function applyThemeColors(themeConfig, defaultTheme) {
  const modes = ['light', 'dark']

  modes.forEach((mode) => {
    const modeConfig = themeConfig?.theme?.[mode]
    const defaultModeTheme = defaultTheme.theme[mode]
    if (!modeConfig) return

    const vuetifyModeTheme = vuetify.framework.theme.themes[mode]
    const keys = Object.keys(modeConfig)

    keys.forEach((key) => {
      const vuetifyKey = mapVuetifyColorKey(key)
      const colorValue = resolveValue(modeConfig[key], defaultModeTheme[key])

      vuetifyModeTheme[vuetifyKey] = colorValue
    })
  })
}

/**
 * Convert API theme color keys to Vuetify-compatible keys.
 *
 * @param {string} key - Original theme key.
 * @returns {string} The mapped Vuetify theme key.
 */
function mapVuetifyColorKey(key) {
  const keyMapping = {
    primary_color: 'primary',
    secondary_color: 'secondary',
  }

  return keyMapping[key] ?? key
}

/**
 * Apply the font family from theme settings.
 *
 * @param {string} font - Requested font family value.
 * @param {string} defaultFont - Fallback font in case of invalid fonts.
 */
function applyFontFamily(font, defaultFont) {
  const finalFont = resolveValue(font, defaultFont)
  const formattedFont = finalFont.replaceAll('_', ' ')

  document.documentElement.style.setProperty('--app-font-family', formattedFont)
}

/**
 * Display a global overlay message.
 *
 * @param {boolean} display - Whether to show or hide.
 * @param {string} [message] - Optional message while loading.
 */
function toggleThemeOverlay(display, message = '') {
  EventBus.$emit('displayGlobalOverlay', {
    display,
    message,
  })
}

// -------------------------------------------------------------
// Watchers
// -------------------------------------------------------------
const watch = {
  /**
   * Watcher triggered whenever the current theme stored in Vuex changes.
   *
   * Responsibilities:
   * - Display a loading overlay while theme updates are applied
   * - Update Vuetify theme colors (light/dark)
   * - Apply fallback values from the default theme when needed
   * - Update global font-family via CSS variables
   */
  '$store.state.currentTheme': {
    handler(currentTheme) {
      toggleThemeOverlay(true, i18n.t('partners.overlay.applyingTheme'))

      applyThemeColors(currentTheme, defaultTheme)
      applyFontFamily(currentTheme.font, defaultTheme.font)

      toggleThemeOverlay(false)
    },
  },

  /**
   * Watcher triggered when store details change.
   * Automatically recomputes the current theme based on the new store configuration.
   */
  '$store.state.currentStoreDetails': {
    handler(storeDetails, oldStoreDetails) {
      //prevent useless compute
      if (JSON.stringify(storeDetails) === JSON.stringify(oldStoreDetails)) return

      const partnerTheme = structuredClone(store.state.partnerTheme)
      store.state.currentTheme = buildCurrentTheme(storeDetails, partnerTheme)
    },
    immediate: true,
    deep: true,
  },

  /**
   * Watcher triggered when the partner theme changes.
   * Useful when theme configuration is updated dynamically (API sync, merchant settings, etc.).
   */
  '$store.state.partnerTheme': {
    handler(partnerTheme, oldPartnerTheme) {
      //prevent useless compute
      if (JSON.stringify(partnerTheme) === JSON.stringify(oldPartnerTheme)) return
      const storeDetails = store.state.currentStoreDetails
      store.state.currentTheme = buildCurrentTheme(storeDetails, structuredClone(partnerTheme))
    },
    immediate: true,
    deep: true,
  },
  '$store.state.locale': {
    handler(newLocale, oldLocale) {
      if (newLocale === oldLocale) {
        return
      }
      let locale = newLocale
      if (!this.$i18n.availableLocales.includes(locale)) {
        locale = this.$i18n.fallbackLocale
      }
      //prevent useless compute
      this.$moment.locale(locale)
      this.$i18n.locale = locale
    },
    immediate: true,
    deep: true,
  },
}
Vue.use(UnifiedStockPlugin, { i18n })

new Vue({
  render: (h) => h(App),
  router,
  store,
  vuetify,
  i18n,
  watch,
}).$mount('#app')
